import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import LockOutline from '@material-ui/icons/LockOutlined';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import LoginStyle from 'assets/jss/views/LoginStyle';
import AuthField from 'components/core/AuthField';
import Button from 'components/core/CustomButtons/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { LOGIN } from '../../actions';
import { AUDIT_SYSTEM, BACKOFFICE_SYSTEM } from '../../actions/system';
import { USER_TYPES } from '../../constants';
import { axiosWithNoErrorHandling } from '../../request';

class TwoFA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      openError: false,
      errorMessage: 'الرمز المدخل غير صحيح.',
      count: 0,
      readableCount: 60,
    };

    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleSearchTermSubmit = this.handleSearchTermSubmit.bind(this);
    this.handleClose = () => {
      this.setState({ openError: false });
    };
  }

  componentDidMount() {
    this.handleSendingCode();
  }

  dispatchCurrentSystem = type => {
    if (type === USER_TYPES.AUDIT_USER) {
      this.props.dispatch(AUDIT_SYSTEM());
    } else {
      this.props.dispatch(BACKOFFICE_SYSTEM());
    }
  };

  handleSendingCode = () => {
    const url = process.env.REACT_APP_API_URL;
    axiosWithNoErrorHandling
      .post(`${url}/v1/auth/code_via_sms`, [], {
        headers: {
          Authorization: `Bearer ${this.props.tempToken}`,
        },
      })
      .then(() => {
        this.handleResetCounter();
      })
      .catch(() => {
        this.setState({
          openError: true,
          errorMessage: 'تعذر إرسال رمز التحقق، الرجاء المحاولة مرة أخرى.',
        });
      });
  };

  handleResetCounter = () => {
    this.setState({
      count: 0,
      readableCount: 60,
    });
  };

  handleIncreaseCounter = () => {
    if (this.state.count > 100) {
      return;
    }

    this.setState(oldState => ({
      count: oldState.count + 1.67,
      readableCount: Math.max(0, oldState.readableCount - 1),
    }));
  };

  handleCodeChange(evt) {
    this.setState({ code: evt.target.value });
  }

  handleSearchTermSubmit(e) {
    e.preventDefault();
    const { code } = this.state;
    const url = process.env.REACT_APP_API_URL;
    const tempToken = this.props.tempToken;

    axiosWithNoErrorHandling
      .post(
        `${url}/v1/auth/verify`,
        { code },
        {
          headers: {
            Authorization: `Bearer ${tempToken}`,
          },
        },
      )
      .then(response => {
        const base64Payload = response.data.token.split('.')[1];
        const decodedPayload = JSON.parse(atob(base64Payload));
        const sub = decodedPayload.sub;
        const permissions = decodedPayload.perm;

        const auth = {
          token: response.data.token,
          AdmRole: sub === 1 || sub === '1',
          userPermissions: permissions,
          type: response.data.type,
        };
        this.props.dispatch(LOGIN(auth));
        this.dispatchCurrentSystem(auth.type);
        this.props.history.push('/dashboard');
      })
      .catch(() => this.setState({ openError: true, errorMessage: 'الرمز المدخل غير صحيح.' }));
  }

  render() {
    const { classes } = this.props;
    const canResend = this.state.count > 100;

    return (
      <form className={classes.loginBox} onSubmit={this.handleSearchTermSubmit}>
        <ResendProgress
          count={this.state.count}
          classes={classes}
          onTick={this.handleIncreaseCounter}
        />
        <p className={classes.formTitle}>مصادقة الدخول</p>
        <p className={classes.formSubtitle}>أدخل رمز التحقق المرسل إلى جوالك</p>
        <div className={classes.fields}>
          <AuthField
            label="الرمز"
            id="code"
            type="tel"
            value={this.state.code}
            onChange={this.handleCodeChange}
            autoFocus
            icon={<LockOutline />}
            inputProps={{
              inputMode: 'numeric',
              autoComplete: 'one-time-code',
              pattern: '[0-9]*',
            }}
          />
        </div>
        <p className={classes.timerText}>
          {canResend
            ? 'يمكنك الآن إعادة إرسال الرمز'
            : `يرجى الانتظار ${this.state.readableCount} ثانية حتى تتمكن من إعادة الإرسال`}
        </p>
        <div className={classes.submitRow}>
          <Button color="primary" type="submit" className={classes.submitBtn}>
            مصادقة
          </Button>
          <Button
            color="secondry"
            className={classes.secondaryBtn}
            disabled={!canResend}
            onClick={this.handleSendingCode}
          >
            إعادة الإرسال
          </Button>
        </div>
        <Snackbar
          className={classes.snackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.openError}
          autoHideDuration={5000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
            className: classes.snackbarContent,
          }}
          message={<span id="message-id">{this.state.errorMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </form>
    );
  }
}

const ResendProgress = ({ count, classes, onTick }) => {
  React.useEffect(() => {
    const timer = setInterval(onTick, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={classes.progressWrap}>
      <div className={classes.progressBar} style={{ width: `${Math.min(count, 100)}%` }} />
    </div>
  );
};

ResendProgress.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onTick: PropTypes.func.isRequired,
};

TwoFA.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  tempToken: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  tempToken: state.auth.tempToken,
});

export default compose(
  withStyles(LoginStyle),
  connect(mapStateToProps),
  withRouter,
)(TwoFA);
